import FormattedMessage from 'I18n/components/FormattedMessage';
import UISection from 'UIComponents/section/UISection';
import { AUTOMATION_EXTENSION, CLASSIC_NOTIFICATION_EMAIL, EMAIL, EMAIL_NOTIFICATION, IN_APP_NOTIFICATION, LIST_BRANCH, SET_PROPERTY, SLACK_NOTIFICATION, WEBHOOK } from 'automation-ui-action-features/constants/ActionTypes';
import EnrollmentDiagnosisButton from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/EnrollmentDiagnosisButton';
import BranchDiagnosisButton from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/BranchDiagnosisButton';
import LogEventDetailField from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/LogEventDetailField';
import LogEventAction from 'automation-ui-log-events/components/LogEventAction';
import LogEventServerResponse from 'automation-ui-log-events/components/LogEventServerResponse';
import LogEventTimestamp from 'automation-ui-log-events/components/LogEventTimestamp';
import LogEventExecutionResultsTable from 'automation-ui-log-events/components/execution-results/LogEventExecutionResultsTable';
import RevisionLinkWithDetails from 'automation-ui-log-events/components/revisions/RevisionLinkWithDetails';
import { LogEventTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { getExecutionCounts } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
import { getActionType, getIdempotencyId, getTimestamp, getType } from 'automation-ui-log-events/records/LogEvent/utils';
import { getActionHistoryHeader } from 'automation-ui-management/components/history/ActionHistoryHeader';
import isEmpty from 'transmute/isEmpty';
import { USER_INPUT_ACTION_TYPE_ID } from 'automation-ui-enrollment/constants/flowInteraction';
import UserInputDetails from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/UserInputDetails';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUPPORTED_EXECUTION_RESULTS_ACTION_TYPES = [SET_PROPERTY, SLACK_NOTIFICATION, EMAIL, EMAIL_NOTIFICATION, IN_APP_NOTIFICATION, CLASSIC_NOTIFICATION_EMAIL];
const EnrollmentHistoryPageLogEventDetails = ({
  logEvent,
  flow,
  flowObjectTypeId,
  extensionDefinitions,
  getActionOutputsForTargetActionById,
  flowLastUpdatedAt
}) => {
  const actionType = getActionType(logEvent);
  const logEventTimestamp = getTimestamp(logEvent) || 0;
  const {
    totalCount
  } = getExecutionCounts(logEvent);
  const showAssociatedExecutionTable = totalCount > 1 && SUPPORTED_EXECUTION_RESULTS_ACTION_TYPES.includes(actionType);
  const showActionLink = flowLastUpdatedAt < logEventTimestamp;
  const isEnrollmentLog = getType(logEvent) === LogEventTypes.ENROLLMENT;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isEnrollmentLog && /*#__PURE__*/_jsx(EnrollmentDiagnosisButton, {
      flowObjectTypeId: flowObjectTypeId,
      flowId: flow.flowId
    }), actionType === LIST_BRANCH && /*#__PURE__*/_jsx(BranchDiagnosisButton, {
      flowObjectTypeId: flowObjectTypeId,
      flowId: flow.flowId,
      logEventIdempotencyId: getIdempotencyId(logEvent)
    }), showAssociatedExecutionTable && /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(LogEventExecutionResultsTable, {
        logEvent: logEvent,
        flowObjectTypeId: flowObjectTypeId
      })
    }), actionType && logEvent.action.actionTypeId === USER_INPUT_ACTION_TYPE_ID ? /*#__PURE__*/_jsx(UserInputDetails, {
      logEvent: logEvent
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LogEventDetailField, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-log-events.logEventDetails.actionHeader"
        }),
        children: isEmpty(extensionDefinitions) ? actionType : /*#__PURE__*/_jsx(LogEventAction, {
          logEvent: logEvent,
          flowObjectTypeId: flowObjectTypeId,
          showActionLink: showActionLink,
          getActionHistoryHeader: getActionHistoryHeader(flow, extensionDefinitions),
          getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
        })
      }), (actionType === AUTOMATION_EXTENSION || actionType === WEBHOOK) && /*#__PURE__*/_jsx(LogEventDetailField, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-log-events.logEventDetails.serverResponseHeader"
        }),
        children: /*#__PURE__*/_jsx(LogEventServerResponse, {
          logEvent: logEvent,
          flowObjectTypeId: flowObjectTypeId
        })
      })]
    }), /*#__PURE__*/_jsx(LogEventDetailField, {
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-log-events.logEventDetails.timeHeader"
      }),
      children: /*#__PURE__*/_jsx(LogEventTimestamp, {
        logEvent: logEvent
      })
    }), /*#__PURE__*/_jsx(LogEventDetailField, {
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-log-events.logEventDetails.revisionHeader"
      }),
      children: /*#__PURE__*/_jsx(RevisionLinkWithDetails, {
        flowId: flow.flowId,
        timestamp: logEventTimestamp
      })
    })]
  });
};
export default EnrollmentHistoryPageLogEventDetails;